<template>
    <ul id="access_type_8">
        <li class="form-label">
            {{ $t('Mailbox Name') }}
        </li>
        <li>
            <cic-textbox
                id="access_name"
                :value="item.name"
                :enabled="editing && !item.accessId"
                :maxlength="255"
                @input="(val) => $emit('change', 'name', val)"
            />
        </li>
        <template v-if="surveys.length">
            <li class="form-label">
                {{ $t('Survey') }}
            </li>
            <li>
                <cic-select
                    id="access_survey"
                    :value="item.surveyId"
                    :enabled="editing"
                    :options="surveys.map((x) => ({ value: x.surveyId, label: x.name }))"
                    clearable
                    @input="(val) => $emit('change', 'surveyId', val)"
                />
            </li>
        </template>
        <template v-if="item.accessId">
            <li class="form-label">
                {{ $t('URL') }}
            </li>
            <li>{{ item.url }}</li>
        </template>
    </ul>
</template>

<script>
    import CicSelect from '@/components/inputs/CicSelect';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditImAccessPoint',
        components: {
            CicSelect,
            CicTextbox,
        },
        props: {
            editing: {
                type: Boolean,
                default: false,
            },
            item: {
                type: Object,
                required: true,
            },
            surveys: {
                type: Array,
                required: true,
            },
        },
        emits: ['change'],
    };
</script>
